import { z } from "zod";

export const schema = z.object({
  id: z.string().optional(),
  key: z.string().min(1, "Key must not be empty"),
  description: z.string().min(1, "Description must not be empty"),
  price: z.coerce.number(),
  stock: z.coerce.number().int().min(0),
  stockLeft: z.coerce.number().int().min(0),
  cost: z.coerce.number().default(0),
  detail: z.string().optional(),
  weight: z.coerce.number().min(0),
  maxQuantity: z.coerce.number().int().default(-1),
  minQuantity: z.coerce.number().int().default(1),
  allowBackorder: z.boolean().optional().default(false),
  sku: z.string().nullable().optional(),
  allowInWeb: z.boolean().optional().default(false),
  webPrice: z.coerce.number(),
  images: z.object({ name: z.string() }).optional().array(),
});

export const stockValidator = ({ stock, stockLeft }) => stock >= stockLeft;
export const stockValidatorMessage = ({ key, stock, stockLeft }) => ({
  path: ["stockLeft"],
  message: `${key}: stock(${stock}) must be greater than or equal to stockLeft(${stockLeft})`,
});

export const SingleTieredPriceSchema = z.string().refine(
  (value) => {
    const parts = value.split("|");

    if (parts.length !== 3) return false;

    const [first, second, price] = parts;
    const isValidFirst = /^\d+$/.test(first);
    const isValidSecond = /^\d+$/.test(second);
    const isValidPrice = /^\d+(\.\d{1,2})?$/.test(price);

    return isValidFirst && isValidSecond && isValidPrice;
  },
  {
    message:
      'Invalid format, should be "3|3|10.00" with first and second as integers and the last as a price',
  }
);

export const TieredPricesSchema = z.array(SingleTieredPriceSchema);
// Example code validate the data
// const result = z.string().refine(value => {
//   return value.split(',').every(item => multiSchema.safeParse(item).success);
// }, {
//   message: 'Invalid format for the list'
// }).safeParse(data);

export const keywordSchema = schema.refine(
  stockValidator,
  stockValidatorMessage
);
